import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ContentPageNavigationItem } from '../../../@types/ContentPage';
import { navigation } from '../../../actions/contentpage';
import Link from '../../../components/link';
import { getContentPageNavigation } from '../../../selectors/content-page';
import Loader from '../../../styled-components/components/Loader';

const filterByParent = (items: ContentPageNavigationItem[], parentId: string) =>
  items.filter((item) => item.parentId === parentId);

interface NavItemProps {
  item: ContentPageNavigationItem;
  items: ContentPageNavigationItem[];
}

const NavItem = ({ item, items }: NavItemProps) => {
  const childItems = (item.isActive ? filterByParent(items, item.id) : []).filter(
    (i) => i.visibleInMenu,
  );

  return (
    <li className={`nav-item${item.isActive ? ' is-active' : ''}`}>
      <Link to={item.url} className="nav-link">
        {item.title}
      </Link>
      {!!childItems.length && (
        <ul className="side-nav">
          {childItems.map((childItem) => (
            <li className={`nav-item${childItem.isActive ? ' is-active' : ''}`} key={childItem.id}>
              <Link to={childItem.url} className="nav-link">
                {childItem.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

const LeftNavigation = () => {
  const dispatch = useDispatch();
  const items = useSelector(getContentPageNavigation);
  const actions = bindActionCreators({ navigation }, dispatch);

  useEffect(() => {
    if (!items) {
      actions.navigation();
    }
  }, []);

  if (items && !items.length) {
    return null;
  }

  return (
    <nav data-am-sidenavigation="">
      {!items && <Loader />}
      {items && (
        <ul className="side-nav">
          {items
            .filter((item) => !item.parentId && item.visibleInMenu)
            .map((item) => (
              <NavItem key={item.id} item={item} items={items} />
            ))}
        </ul>
      )}
    </nav>
  );
};

export default LeftNavigation;
